import { Link } from "react-router-dom";
import { SiteLayout } from "./home/SiteLayout";
import { PageHero } from "./home/components/PageHero";
import { Icon } from "./home/components/Icon";
import { RichText, useSiteTranslation } from "./home/i18n";
import "./safety.css";

export default function NotFoundComponent() {
  const { t } = useSiteTranslation();

  return (
    <SiteLayout title={t("notFound.title")} noindex>
      <PageHero eyebrow="404" title={<RichText k="notFound.heading" />} lead={t("notFound.lead")}>
        <div className="safety-hero-actions">
          <Link className="safety-button" to="/">
            {t("notFound.home")} <Icon name="arrow" />
          </Link>
          <Link className="safety-text-link" to="/help">
            {t("notFound.help")}
          </Link>
        </div>
      </PageHero>
    </SiteLayout>
  );
}
